var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBECED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6506 27.7426C16.1966 29.9256 16.4696 31.0166 17.2826 31.6526C18.0966 32.2876 19.2216 32.2876 21.4716 32.2876H26.1016C28.3516 32.2876 29.4766 32.2876 30.2916 31.6526C31.1046 31.0166 31.3776 29.9256 31.9226 27.7426C32.7806 24.3106 33.2096 22.5956 32.3096 21.4416C31.4086 20.2876 29.6396 20.2876 26.1026 20.2876H21.4716C17.9336 20.2876 16.1656 20.2876 15.2646 21.4416C14.7356 22.1186 14.6646 22.9896 14.8706 24.2876",
    stroke: "#354147",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2871 20.7876L30.5771 18.1826C30.3031 17.1776 30.1661 16.6756 29.8851 16.2966C29.6049 15.9201 29.2244 15.63 28.7871 15.4596C28.3471 15.2876 27.8271 15.2876 26.7871 15.2876M16.2871 20.7876L16.9971 18.1826C17.2711 17.1776 17.4081 16.6756 17.6891 16.2966C17.9693 15.9201 18.3498 15.63 18.7871 15.4596C19.2271 15.2876 19.7471 15.2876 20.7871 15.2876",
    stroke: "#354147",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7871 15.2876C20.7871 15.0224 20.8925 14.768 21.08 14.5805C21.2675 14.393 21.5219 14.2876 21.7871 14.2876H25.7871C26.0523 14.2876 26.3067 14.393 26.4942 14.5805C26.6818 14.768 26.7871 15.0224 26.7871 15.2876C26.7871 15.5528 26.6818 15.8072 26.4942 15.9947C26.3067 16.1822 26.0523 16.2876 25.7871 16.2876H21.7871C21.5219 16.2876 21.2675 16.1822 21.08 15.9947C20.8925 15.8072 20.7871 15.5528 20.7871 15.2876Z",
    stroke: "#354147",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.d4762869ee8a281b6f81f49ccee32c8d.svg";
export { ForwardRef as ReactComponent };